import XAPIHelper from "./XAPIHelper";
import PlayerConstants from '../../utils/PlayerConstants';

class CExApi {
    constructor(user, course, platform, isScorm) {
        this.wrapper = null;
        this.statementQueue = [];
        this.stateId = 0
        this.userInfo = user;
        this.course = course
        this.platform = platform;
		this.isScorm = isScorm;
        this.stateId = this.userInfo?.uid + '_' + this.course.course_Id;
        this.helper = new XAPIHelper(user,course);
		this.lan = ""

		 
    }

	// endpoint: "https://tradecompliancecourses.com/ceauthor/api/",
	// endpoint: "https://tradecompliance.training/xapice/api/",
    initialise = async () => { 
        var ref = this;
		return new Promise((resolve, reject) => {
        try {
            const ADL = window.ADL;
            ADL.launch(function (err, launchdata, xAPIWrapper) {
                console.log("------------->>",)
                if (!err) {
                    this.wrapper = ADL.XAPIWrapper = xAPIWrapper;
                    console.log("--- content launched via xAPI Launch ---\n", this.wrapper.lrs, "\n", launchdata);
                } else {
                    ref.wrapper = ADL.XAPIWrapper;
					/* if xapi learning standard is there all config is taken by wrapper from URL 
					only required for our lms and if we want to set config mannualy
					*/
					if(!window.ce.isXapi){
						ref.wrapper.changeConfig({
							endpoint: PlayerConstants.STG_HOSTNAMES.indexOf(window.location.hostname) !== -1 ? "https://tradecompliance.training/xapice/api/" : "https://beta-cached.contentenablers.com/api/",
							user: '',
							password: ''
						});
						//  never to be present in xapi only required for ce customised data
						ref.wrapper.updateUserInfo(Object.assign({ auth: ref.platform.authtoken, cid: ref.platform.cid }, ref.userInfo))
						console.log(ref.wrapper,"--- content statically configured ---\n");
					}
					resolve(true)
					}
            }, true);

        } catch (error) {
			console.log(error)
        }
	})
    }

    trackActivity = (type, isConnect, params) =>{
        let stmt ={};
        // deep cloning method
		stmt =JSON.parse(JSON.stringify(this.helper.getStatement(type, params)));
		const isDescriptionPresent = this.statementQueue?.some((interaction) => {
			return (interaction?.object?.definition?.description["en-US"]||"") === (stmt?.object?.definition?.description["en-US"] || "");
		  });

		if(isConnect === 1)	{
			//this.saveLearning(stmt)
		}
		else if(isConnect === -1 && !this.isScorm && !isDescriptionPresent)	{
		    this.statementQueue=[...this.statementQueue,{...stmt}];
			this.saveLearning(this.statementQueue)
		}else if(isConnect === -1 && this.isScorm && !isDescriptionPresent && Number(window?.ce?.platform_scorm?.pvtId) === 86 )   {
            this.statementQueue=[...this.statementQueue,{...stmt}];
            this.saveLearning(this.statementQueue)
        }
		else if(isConnect === 0)	{
			if(!isDescriptionPresent) this.statementQueue=[...this.statementQueue,{...stmt}];
		}

		console.log(type, "---------------" , this.statementQueue)
	}

	saveLearning = (stmt) =>{
		var ref = this;
		if(stmt.length)	{
			stmt.map(item =>{
				delete item.id;
				return item;
			})
			this.wrapper.sendStatements(stmt, (res, data) =>{
				ref.stateId = data.id;
				ref.statementQueue = []
				console.log(data)
			});
		}
		else	{
			this.wrapper.sendStatement(stmt, (res, data) =>{
				ref.stateId = data.id;
				console.log(data.id)
			});
		}
	}


	saveAppState = ( stateVal) =>{
		let bstate = this.helper.getBaseState();
		let stateId = this.helper.getStateId()
		// need to parse data if xapi-client
		if(window.ce.isXapi){
			this.wrapper.sendState(bstate.activityId,JSON.parse(bstate.agent), stateId, null,{a:Math.random(), ...stateVal},null, null,(data)=>{
				console.log("SAVED DATA TO LRS ")
			})
		}
		else{

			this.wrapper.sendState(bstate.activityId,bstate.agent, stateId, null,{a:Math.random(), ...stateVal},null, null,(data)=>{
				console.log("SAVED DATA TO LRS ")
			})
		}
	}

	getAppState = () =>	{
		try{
		console.log('getAppState ^^^^^^^^^^^^^^^^^^^^^^^')
		let bstate = this.helper.getBaseState();
		let stateId = this.helper.getStateId()
		console.log('getAppState',stateId,bstate)
		// need to parse data if xapi-client
		if(window.ce.isXapi){

			var state = this.wrapper.getState(bstate.activityId,JSON.parse(bstate.agent), stateId );
		}
		else{
			var state = this.wrapper.getState(bstate.activityId,bstate.agent, stateId );
		}
		console.log('getAppState')
		console.log(state)
		return state;
	}catch(e){
		console.log("getAppState *****",e);
		
	}
	}


}

export default CExApi;
